module.exports = __webpack_public_path__ + "media/images/errors/server-4a6915e7e0b5add006a58b5f80d5485f.png";